import { reactive } from 'vue';

export default function () {
  const lookupResults = reactive([]);
  let lookupTimeout = null;
  let Place = null;
  let AutocompleteSuggestion = null;

  const request = {
    input: '',
    locationBias: { lat: 44.9312227, lng: -123.2372981 },
    includedRegionCodes: ['US'],
    language: 'en-US',
    region: 'us',
  };

  async function init() {
    const { Place: tempP, AutocompleteSessionToken, AutocompleteSuggestion: tempAS } = await google.maps.importLibrary('places');
    request.sessionToken = new AutocompleteSessionToken();
    Place = tempP;
    AutocompleteSuggestion = tempAS;
  }

  init();

  async function getSuggestions() {
    const { suggestions } = await AutocompleteSuggestion.fetchAutocompleteSuggestions(request);

    lookupResults.length = 0;

    for (const suggestion of suggestions) {
      if (lookupResults.length > 1) break;

      let place = suggestion.placePrediction.toPlace();
      await place.fetchFields({
        fields: ['addressComponents', 'formattedAddress'],
      });

      const newAddress = {};
      let address1 = '';

      for (const component of place.addressComponents) {
        const componentType = component.types[0];

        switch (componentType) {
          case 'street_number': {
            address1 = `${component.longText} ${address1}`;
            break;
          }
          case 'route': {
            address1 += component.shortText;
            break;
          }
          case 'locality':
            newAddress.city = component.longText;
            break;
          case 'postal_code': {
            newAddress.zip = component.longText;
            break;
          }
          case 'administrative_area_level_1': {
            newAddress.state = component.shortText;
            break;
          }
        }
      }

      newAddress.formattedAddress = place.formattedAddress;
      newAddress.address = address1;
      lookupResults.push(newAddress);
    }
  }

  function addressLookup(address, city, state, zip) {
    clearTimeout(lookupTimeout);
    if (!address && !city && !zip) return;
    let addressString = address;
    city && addressString ? (addressString += `, ${city}`) : (addressString += city || '');
    state && addressString ? (addressString += `, ${state}`) : (addressString += state || '');
    zip && addressString ? (addressString += ` ${zip}`) : (addressString += zip || '');
    request.input = addressString;

    lookupTimeout = setTimeout(() => {
      getSuggestions();
    }, 500);
  }

  return {
    addressLookup,
    lookupResults,
  };
}
